// extracted by mini-css-extract-plugin
export var auto = "_44-1";
export var spinner = "_44-0";